import queryString from 'query-string';
import { jsonp } from 'vue-jsonp';
import { createClickId } from './createClickId';
import {
  GET_ADD_FRIEND_SCHEME,
  ROUTE_CHANGE_LOADING_QQ,
  GET_TENCENT_SCHEME,
} from '@/utils/api';

import DOMAIN from '@/imsdk/domain';
const domain = DOMAIN.getSDKDomain();


export const getWebViewType = function (ua) {
  let type = 'other';
  if (/(ipad|iphone|ipod).*? (ipad)?qq\/([\d.]+)|\bv1_and_sqi?_([\d.]+)(.*? qq\/([\d.]+))?/i.test(ua)) {
    type = 'mqq';
  } else if (/micromessenger/i.test(ua)) {
    type = 'wechat';
  }
  return type;
};

const getUrlQuery = function (url) {
  return url.substring(url.indexOf('?') + 1);
};
const ua = navigator.userAgent;

export const invoke = function (customScheme, payload = { isInIframe: false, isMobile: false }) {
  // 重构这个参数没有了，先写成一个空对象，后续根据需求进行调整
  const specificSignT = {};
  const isInMQQWebView = getWebViewType(ua) === 'mqq';
  let PCQQChatIframe;
  let docBody;
  if (payload.isMobile) {
    // 移动端
    if (payload.isInIframe) {
      const sign = customScheme.replace(/\+/gi, '%2B');
      window.parent.postMessage({
        act: 'LAUNCH',
        type: 'PHONE',
        sign,
        protocol: `${domain.consolecgi + ROUTE_CHANGE_LOADING_QQ}?fromWebIm=1&${queryString.stringify(specificSignT)}&protocol=${sign}`,
      }, '*');
    } else if (isInMQQWebView) {
      top.location.href = customScheme;
    } else {
      top.location.href = `${domain.consolecgi + ROUTE_CHANGE_LOADING_QQ}?${getUrlQuery(window.location.href)}&protocol=${customScheme}`;
    }
  } else {
    // PC端
    // 当是pc并且不是ie，才href跳转呼起
    if (window.location.protocol === 'https' && ua.indexOf('msie') === -1) {
      window.location.href = customScheme;
    } else {
      PCQQChatIframe = document.createElement('iframe');
      docBody = document.body;
      PCQQChatIframe.style.display = 'none';
      docBody.insertBefore(PCQQChatIframe, docBody.firstChild);
      PCQQChatIframe.src = customScheme;
    }
  }
};


export const addQQ = function (params = {}) {
  window.bindCallQQEvent = function (data) {
    if (data && data.r === 0 && typeof data.data.sign !== 'undefined') {
      invoke(data.data.sign, params);
    }
  };
  jsonp(domain.consolecgi + GET_ADD_FRIEND_SCHEME, {
    cb: 'bindCallQQEvent',
    kfext: params.kfext,
    kfaccount: params.kfaccount,
    kfuin: params.kfuin,
    visitorId: params.visitorId,
    ftype: params.ftype,
    clickid: createClickId(),
    _: Date.now(),
  });
};

export const qqInvite = function (params = {}) {
  window.bindCallQQEvent = function (data) {
    if (data && data.r === 0 && typeof data.data.sign !== 'undefined') {
      invoke(data.data.sign, params);
    }
  };
  jsonp(domain.consolecgi + GET_TENCENT_SCHEME, {
    cb: 'bindCallQQEvent',
    // 必须的参数
    kfuin: params.kfuin,
    visitorId: params.visitorId,
    fid: params.fid,
    roleValue: params.roleValue,
    ftype: params.ftype,
    roleData: params.roleData,
    clickid: createClickId(),
    isCorpUin: params.isCorpUin,
    reqPos: '0',
    // 上报参数
    cate: '',
    type: '',
    pid: '',
    qid: '',
    clickType: '',
    tptype: '',
    eptype: '',
    tpForm: '',
    waitTime: '',
    rolekey: 'roleQQ',
    reqSrc: 'routeChange',
    _: Date.now(),
    waitTime: '',
    callImType: '',
    qidian_track_id: '',
    qidian_src_desc: '',
    qidian_ex1: '',
    qidian_ex2: '',
    qidian_ex3: '',
    qidian_ex4: '',
    qidian_ex5: '',
    guestId: '',
    qidian_lang: '',
  });
};

// callback: jQuery1124008229163307304166_1677066380814
// visitorId: 492976878137405
// cate: 7
// type: 10
// pid: ca4wlz.b62nif.lefm0u35
// qid: ca4wlz.b62nif.lefm0u35
// clickType: 6
// tptype: 9
// eptype: 1
// tpForm: 2
// kfuin: 2852199203
// roleValue: 0
// roleData: 3007440460
// fid: 1785
// clickid: lgc5ez.ocsphs.lefm0xfv
// waitTime:
// callImType:
// qidian_track_id:
// qidian_src_desc:
// qidian_ex1:
// qidian_ex2:
// qidian_ex3:
// qidian_ex4:
// qidian_ex5:
// guestId:
// qidian_lang:
// rolekey: roleQQ
// cb: bindCallQQEvent
// reqPos: 0
// reqSrc: routeChange
// isCorpUin: 0
// _: 1677066380816
